import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTotalSalesSummaryV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.totalSalesSummaryV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTotalSalesSummaryV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicTotalSales: res.data.data.report.clinic_total_sales_summary,
        providerTotalSales: res.data.data.report.provider_total_sales_summary,
      };
      return composeResponse;
    },
    options,
  );
};
